/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Slogan_2_PrefixInputs */



/**
* | output |
* | --- |
* | "Power, meet" |
*
* @param {Auth_Slogan_2_PrefixInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_slogan_2_prefix = /** @type {((inputs?: Auth_Slogan_2_PrefixInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Slogan_2_PrefixInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Leistung trifft")
	return /** @type {LocalizedString} */ ("Power, meet")
});